import {
  IAllocationActivity,
  IAllocationBudgetControl,
  IAllocationCostCenter,
  IAllocationLineItem,
  IAllocationLink,
  IAllocationReadiness,
  IAllocationSummary,
  IActivityBudgetHeader,
  IActivityBudgetRegister,
} from './budgetallocation.models';

const n = (value: any, fallback = 0) => {
  const result = Number(value);
  return Number.isFinite(result) ? result : fallback;
};

const s = (value: any, fallback = '') =>
  value === null || value === undefined ? fallback : String(value);

// export const normalizeAllocationCostCenter=(r:any):IAllocationCostCenter=>({
//   recid:n(r.recid??r.rid??r.id),
//   shortcode:s(r.shortcode??r.shc??r.costcentercode??r.ccc),
//   recname:s(r.recname??r.nam??r.costcentername??r.ccn),
//   activity_count:n(r.activity_count??r.activities??r.act),
//   allocated_amount:n(r.allocated_amount??r.amount??r.amt),
// });

export const normalizeAllocationActivity = (r: any): IAllocationActivity => ({
  id: r.activityplanid ?? r.recid ?? r.rid,
  recid: r.activityplanid ?? r.recid ?? r.rid,
  activityplanid: r.activityplanid ?? r.recid ?? r.rid,
  activityid: r.activityid ?? r.aci,
  shortcode: s(r.shortcode ?? r.activitycode ?? r.shc),
  recname: s(r.recname ?? r.activityname ?? r.nam),
  description: s(r.description ?? r.dsc),
  ccid: r.ccid ?? r.costcenterid,
  costcenter_code: s(r.costcenter_code ?? r.costcentercode ?? r.ccc),
  costcenter_name: s(r.costcenter_name ?? r.costcentername ?? r.ccn),
  periodid: r.periodid ?? r.pei,
  periodcode: s(r.periodcode ?? r.pec),
  cycleid: r.cycleid ?? r.cyi,
  cyclecode: s(r.cyclecode ?? r.cyc),
  plannedamount: n(r.plannedamount ?? r.planned_amount ?? r.pam),
  allocation_count: n(r.allocation_count ?? r.links),
  allocated_amount: n(r.allocated_amount ?? r.amount ?? r.amt),
  remainingamount: n(r.remainingamount ?? r.remaining_amount ?? r.rem),
  allocation_status: s(r.allocation_status ?? r.statusname),
  statecode: s(r.statecode ?? r.stc),
  statename: s(r.statename ?? r.stn),
});

export const normalizeAllocationLineItem = (r: any): IAllocationLineItem => ({
  id: r.recid ?? r.rid ?? r.id,
  recid: r.recid ?? r.rid ?? r.id,
  shortcode: s(r.accountcode ?? r.shortcode ?? r.shc),
  displaycode: s(r.displaycode ?? r.lineitemcode ?? r.shortcode ?? r.shc),
  recname: s(r.recname ?? r.nam ?? r.accountname),
  description: s(r.description ?? r.dsc),
  budgetplanid: r.budgetplanid ?? r.bpi,
  code_length: n(r.code_length ?? r.codelength),
  allocation_count: n(r.allocation_count ?? r.links),
  allocated_amount: n(r.allocated_amount ?? r.amount ?? r.amt),
});

export const normalizeAllocationLink = (r: any): IAllocationLink => ({
  id: r.recid ?? r.rid ?? r.id,
  recid: r.recid ?? r.rid ?? r.id,
  budgetplanid: r.budgetplanid ?? r.bpi,
  activityplanid: r.activityplanid ?? r.api,
  activityid: r.activityid ?? r.aci,
  activity_code: s(r.activity_code ?? r.activitycode),
  activity_name: s(r.activity_name ?? r.activityname),
  ccid: r.ccid ?? r.costcenterid,
  costcenter_code: s(r.costcenter_code ?? r.costcentercode),
  costcenter_name: s(r.costcenter_name ?? r.costcentername),
  lineitemid: r.lineitemid ?? r.accountid,
  lineitem_code: s(r.accountcode ?? r.lineitem_code ?? r.lineitemcode),
  lineitem_displaycode: s(r.lineitem_displaycode ?? r.lineitemcode),
  lineitem_name: s(r.lineitem_name ?? r.lineitemname),
  allocationratio: n(r.allocationratio ?? r.ratio),
  allocatedamount: n(r.allocatedamount ?? r.allocated_amount ?? r.amount),
  status: n(r.status ?? r.sts, 1),
});

export const normalizeAllocationSummary = (r: any): IAllocationSummary => ({
  costcenters: n(r?.costcenters ?? r?.costcenter_count),
  activities: n(r?.activities ?? r?.activity_count ?? r?.activitycount),
  allocated_activities:n(r?.allocatedactivities??r?.allocated_activities??r?.budgetedcount),
  unallocated_activities:n(r?.unallocatedactivities??r?.unallocated_activities??r?.pendingcount),
  allocation_links: n(r?.allocationlinks ?? r?.allocation_links ?? r?.links),
  planned_amount: n(r?.plannedamount ?? r?.planned_amount),
  allocated_amount:n(r?.allocatedamount??r?.allocated_amount??r?.financialisedamount??r?.amount),
  remaining_amount:n(r?.remainingamount??r?.remaining_amount??r?.planningremainingamount),

  cansubmit: Boolean(r?.cansubmit),
  activitycount: n(r?.activitycount ?? r?.activity_count ?? r?.activities),
  completeactivitycount: n(r?.completeactivitycount),
  budgetedcount: n(r?.budgetedcount),
  pendingcount: n(r?.pendingcount),
  partialcount: n(r?.partialcount),
  varianceupcount: n(r?.varianceupcount),
  variancedowncount: n(r?.variancedowncount),
  noallocationrequiredcount: n(r?.noallocationrequiredcount),
  requiredcount: n(r?.requiredcount),
  requiredreadycount: n(r?.requiredreadycount),
  requiredpendingcount: n(r?.requiredpendingcount),
  requiredpartialcount: n(r?.requiredpartialcount),
  requiredvariancecount: n(r?.requiredvariancecount),
  requirednoallocationcount: n(r?.requirednoallocationcount),
  plannedamount: n(r?.plannedamount ?? r?.planned_amount),
  allocatedamount: n(r?.allocatedamount ?? r?.allocated_amount),
  financialisedamount:n(r?.financialisedamount??r?.allocatedamount??r?.allocated_amount),
  remainingamount: n(r?.remainingamount ?? r?.remaining_amount),
  planningremainingamount:n(r?.planningremainingamount??r?.remainingamount??r?.remaining_amount),
  varianceamount: n(r?.varianceamount),
});

export const normalizeActivityBudgetRegister=(r:any):IActivityBudgetRegister=>({
  id: r.activityplanid ?? r.recid ?? r.rid,
  recid: r.activityplanid ?? r.recid ?? r.rid,
  activityplanid: r.activityplanid ?? r.recid ?? r.rid,
  activityplanix: s(r.activityplanix),
  activityid: r.activityid,
  activitycode: s(r.activitycode ?? r.shortcode),
  activityname: s(r.activityname ?? r.recname),
  costcenterid: r.costcenterid ?? r.ccid,
  costcentercode: s(r.costcentercode ?? r.costcenter_code),
  costcentername: s(r.costcentername ?? r.costcenter_name),
  taskcount: n(r.taskcount),
  budgetlinecount: n(r.budgetlinecount),
  plannedamount: n(r.plannedamount),
  allocatedamount: n(r.allocatedamount ?? r.financialisedamount),
  financialisedamount: n(r.financialisedamount ?? r.allocatedamount),
  remainingamount: n(r.remainingamount),
  planningremainingamount: n(r.planningremainingamount ?? r.remainingamount),
  varianceamount: n(r.varianceamount),
  variancepercent:
    r.variancepercent === null || r.variancepercent === undefined
      ? null
      : n(r.variancepercent),
  allocationcount: n(r.allocationcount),
  linkedlinecount: n(r.linkedlinecount),
  linkingstatecode: s(r.linkingstatecode),
  linkingstatename: s(r.linkingstatename),
  activitystatecode: s(r.activitystatecode),
  activitystatename: s(r.activitystatename),
  submitrequired: Boolean(r.submitrequired),
  submitready: Boolean(r.submitready),
  stamp: s(r.stamp),
});

export const normalizeActivityBudgetHeader=(r:any):IActivityBudgetHeader=>({
  activitybudgetid: n(r?.activitybudgetid),
  planningcycleid: n(r?.planningcycleid),
  budgetcontrolid: r?.budgetcontrolid ?? null,
  stateid: n(r?.stateid),
  statecode: s(r?.statecode),
  statename: s(r?.statename),
  versionno: n(r?.versionno),
  iscurrent: n(r?.iscurrent),
  submittedat: r?.submittedat ?? null,
  submittedby: r?.submittedby ?? null,
  returnedat: r?.returnedat ?? null,
  returnedby: r?.returnedby ?? null,
  returnreason: r?.returnreason ?? null,
  stamp: s(r?.stamp),
});

export const normalizeActivityBudgetControl=(raw:any):IAllocationBudgetControl=>{
  const source = Array.isArray(raw)
    ?raw.find(item=>String(item?.controlareacode??'').toUpperCase()==='ACTIVITY')
    : raw?.controlareacode
      ? raw
      : {};

  return {
    budgetcontrolid: source?.budgetcontrolid ?? null,
    statecode: s(source?.statecode),
    iscurrent: n(source?.iscurrent),
    controlareacode: 'ACTIVITY',
    controlareaname: s(source?.controlareaname, 'Activity Budget'),
    ceilingamount: n(source?.ceilingamount),
    allocatedamount: n(source?.allocatedamount),
    availableamount: n(source?.availableamount),
    utilisationpercent: n(source?.utilisationpercent),
    warningpercent: n(source?.warningpercent, 90),
    controlstatus: s(source?.controlstatus, 'UNAVAILABLE'),
    currencycode: s(source?.currencycode, 'XOF'),
  };
};

export const deriveAllocationReadiness = (
  activities: IAllocationActivity[],
  control:IAllocationBudgetControl,
): IAllocationReadiness => {
  const rows = activities ?? [];

  return {
    controlavailable:Boolean(control.budgetcontrolid)
      &&['ACTIVE','REVIEWED','DRAFT'].includes(
        String(control.statecode??'').toUpperCase(),
      ),
    withincontrol:
      Number(control.allocatedamount) <= Number(control.ceilingamount),
    activitycount: rows.length,
    mappedactivitycount: rows.filter(
      row=>Number(row.allocation_count??0)>0,
    ).length,
    unmappedactivitycount: rows.filter(
      row=>Number(row.allocation_count??0)===0,
    ).length,
    ratioonlycount: rows.filter(
      row=>String(row.allocation_status??'').toUpperCase()==='RATIO_ONLY',
    ).length,
    fullyallocatedcount: rows.filter(
      row=>Number(row.remainingamount??0)===0
        &&Number(row.plannedamount??0)>0,
    ).length,
  };
};

export const normalizeAllocationCostCenter = (
  r: any
): IAllocationCostCenter => ({
  recid: n(r.recid ?? r.rid ?? r.id ?? r.costcenterid),

  shortcode: s(r.shortcode ?? r.shc ?? r.costcentercode ?? r.ccc),

  recname: s(r.recname ?? r.nam ?? r.costcentername ?? r.ccn),

  budgetplanid: n(r.budgetplanid ?? r.budget_plan_id),

  activity_count: n(
    r.activitycount ?? r.activity_count ?? r.activities ?? r.act
  ),

  planned_amount: n(r.plannedamount ?? r.planned_amount),

  allocated_amount: n(
    r.allocatedamount ?? r.allocated_amount ?? r.amount ?? r.amt
  ),
});
